<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14"><path stroke="currentColor" d="M608 26.036V14.379" style="fill:none;stroke-linecap:round;stroke-width:1.4px" transform="rotate(45 323.235 -711.954)" fill="currentColor"/><path stroke="currentColor" d="M610.861 15.365h6v6" style="stroke-linejoin:round;fill:none;stroke-linecap:round;stroke-width:1.4px" transform="translate(-605.861 -12.365)" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-jump',
});
</script>
